/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PagingAndSortingRequestParam } from './PagingAndSortingRequestParam';
import type { PftDetailFilter } from './PftDetailFilter';

export type PftDetailRequest = {
    filter?: PftDetailFilter;
    pagingAndSortingRequestParam?: PagingAndSortingRequestParam;
    exposeType?: PftDetailRequest.exposeType;
}

export namespace PftDetailRequest {

    export enum exposeType {
        EXCEL = 'EXCEL',
        PDF = 'PDF',
        WORD = 'WORD',
        HTML = 'HTML',
        XML = 'XML',
        JSON = 'JSON',
        CSV = 'CSV',
    }


}
